import { customerServiceLiveConversationsEntryPoint } from '@jira/spa-apps__customer-service-live-conversations/src/customerServiceLiveConversationsEntryPoint.entrypoint.tsx';
import { customerServiceLiveConversationsRoute } from '@jira/router-routes__customer-service-live-conversations-routes/src/customerServiceLiveConversationsRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { omniSubAccountStatus } from '@jira/router-resources__customer-service-common/src/omniSubAccountStatus.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { serviceDeskContextResource } from '@jira/router-resources__service-desk-context/src/serviceDeskContextResource.tsx';
import { featuresResource } from '@jira/router-resources__service-project-features/src/featuresResource.tsx';
import type { Route } from '@atlassian/react-resource-router';

const customerServiceLiveConversationsPageEntryPoint = createPageEntryPoint({
	main: customerServiceLiveConversationsEntryPoint,
});

export const customerServiceLiveConversationsRouteEntry: Route = createEntry(
	customerServiceLiveConversationsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.live-conversations',
		layout: globalLayout,

		entryPoint() {
			return fg('csm-omni-channel-live-chat-in-widget')
				? customerServiceLiveConversationsPageEntryPoint
				: notFoundPageEntrypoint;
		},

		resources: [
			...getNavigationResources(),
			serviceDeskContextResource,
			featuresResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			omniSubAccountStatus,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
